import { render, staticRenderFns } from "./u-tab-slider.vue?vue&type=template&id=96b14284&scoped=true&"
import script from "./u-tab-slider.vue?vue&type=script&lang=js&"
export * from "./u-tab-slider.vue?vue&type=script&lang=js&"
import style0 from "./u-tab-slider.vue?vue&type=style&index=0&id=96b14284&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b14284",
  null
  
)

export default component.exports